import { appstr } from "../utils/appstr";
import { Div2Floor } from "../utils/Div2Floor";
import {
  enumButtonLabelPosition,
  enumElementDrawStates,
  kTabButtonHeight,
  kTabMargin
} from "../constants";
import { QStdButton } from "./QStdButton";
import { SetCtxFont } from "../utils/SetCtxFont.js";
import { MeasureTextHeight } from "../utils/MeasureTextHeight.js";
import { MeasureText } from "../utils/MeasureText.js";

export class QTabButton extends QStdButton {
  constructor() {
    super();
    this.fFrontTab = false;
    this.fTabID = null;
    this.fParentPanel = null;
    this.fLabelCode = null;
    this.fFontString = "12px Arial";
    this.fLabelPosition = enumButtonLabelPosition.center;
    this.fDoBoldAnimation = true;
  }

  InitTabButton(parent, label, cmdCode, x, y, buttonW, buttonH) {
    this.fLabelCode = label;
    this.fParentPanel = parent;
    this.fUIColors = parent.fWSMgr.GetUIColors();
    this.fTxtFillStyle = this.fUIColors.GetHeaderTextColor();
    this.SetFillColor(this.fUIColors.GetButtonFillColor());
    this.SetBorderColor(this.fUIColors.GetButtonBorderColor());
    this.SetLabel(label);
    this.PositionElement(x, y);
    this.SizeElement(buttonW, buttonH);
    this.SetCmdCode(cmdCode);
    this.fTabID = cmdCode;
  }

  SetBoldAnimation(animate) {
    this.fDoBoldAnimation = animate;
  }

  ResetLabel() {
    this.SetLabel(appstr(this.fLabelCode));
  }

  GetTabID(tabID) {
    return this.fTabID;
  }

  DoCalculateMinWidth() {
    var ctx = this.fMeasureBuffer.getContext("2d");

    SetCtxFont(ctx, this.fFontString);
    var txt = this.fLabel;
    var txtDim = ctx.measureText(txt);
    var txtWidth = Math.ceil(txtDim.width);

    txtWidth = txtWidth + kTabMargin * 2;
    return txtWidth;
  }

  AutoSize() {
    var minWidth = this.CalcMinWidth();
    this.SizeElement(minWidth, kTabButtonHeight);
  }

  DrawPad(drawBuffer, hover, extend) {
    var ctx = drawBuffer.getContext("2d");

    ctx.strokeStyle = this.fUIColors.GetHeaderTextColor();
    ctx.fillStyle = this.fFillColor;
    ctx.lineWidth = 3;
    var txtHOffset = Div2Floor(this.fWidth);
    var fontString = this.fFontString;
    if (this.fFontString != null) {
      fontString = this.fFontString;
    }
    SetCtxFont(ctx, fontString);
    var labelW = MeasureText(this.fLabel, this.fFontString);
    var sx = this.fHorzOffset + 0.5 - labelW / 2 + txtHOffset - 3;
    var ex = this.fHorzOffset + 0.5 + labelW / 2 + txtHOffset + 3;
    var ey = this.fVertOffset + this.fHeight - 2.5;

    if (hover) {
      ctx.beginPath();
      ctx.moveTo(sx, ey);
      ctx.lineTo(ex, ey);
      ctx.stroke();
    }
    if (extend) {
      ctx.beginPath();
      ctx.moveTo(sx - 5, ey);
      ctx.lineTo(ex + 5, ey);
      ctx.stroke();
    }
    ctx.fill();
  }

  DoRenderElement(drawBuffer) {
    var txtFillStyle = this.fUIColors.GetHeaderTextColor();
    var ds = this.GetDrawState();
    // Draw the button (interior and border)
    switch (ds) {
      case enumElementDrawStates.Std:
        this.DrawPad(drawBuffer, this.fFrontTab, false);
        break;
      case enumElementDrawStates.Hover:
      case enumElementDrawStates.MouseDown:
        this.DrawPad(
          drawBuffer,
          this.fFrontTab,
          this.fFrontTab && ds === enumElementDrawStates.Hover
        );
        break;
      case enumElementDrawStates.Disabled:
        txtFillStyle = "#AFAFAF";
        break;
    }

    // draw label
    this.DrawLabel(drawBuffer);
  }

  DrawLabel(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var ds = this.GetDrawState();
    var txtFillStyle = this.fTxtFillStyle;
    switch (ds) {
      case enumElementDrawStates.Std:
      case enumElementDrawStates.Hover:
      case enumElementDrawStates.MouseDown:
        break;
      case enumElementDrawStates.Disabled:
        txtFillStyle = "#AFAFAF";
        break;
    }
    ctx.fillStyle = txtFillStyle;

    var fontString = this.fFontString != null ? this.fFontString : "12px Arial";

    var renderTextBold =
      this.fFrontTab ||
      this.fCurDrawState === enumElementDrawStates.Hover ||
      this.fSelected ||
      this.fIsActive;
    var doBoldAnimation = this.fDoBoldAnimation && renderTextBold;
    if (doBoldAnimation) fontString = "bold " + fontString;

    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";
    var txtHOffset = Div2Floor(this.fWidth);
    var labelText = this.fLabel;
    var xPos, yPos;
    switch (this.fLabelPosition) {
      case enumButtonLabelPosition.below:
        xPos = this.fHorzOffset + txtHOffset;
        yPos = this.fVertOffset + this.fHeight - 4;
        break;
      case enumButtonLabelPosition.center:
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + txtHOffset;
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
      case enumButtonLabelPosition.left:
        var labelW = this.MeasureLabel();
        var txtHIndent = 6;
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + labelW / 2 + txtHIndent + this.fLabelInset;
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
    }
    SetCtxFont(ctx, fontString);
    ctx.fillText(labelText, xPos, yPos, this.GetWidth());
  }

  SetFrontTab(frontTab) {
    this.fFrontTab = frontTab;
  }
}
